import { createTermTagManager } from '../../utils/createTermTagManager';

export const hasHeatingTagManager = createTermTagManager({
  jsonQueryKey: 'has_heating',
  label: 'Есть отопление',
  id: 'hasHeating',
});
